/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassCocktailIcon24Solid = forwardRef('FoodDrinkAlcoGlassCocktailIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 10.5A5 5 0 1 0 14.229 4H3.477C1.827 4 .96 5.96 2.072 7.18L10 15.883V20H5.5a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H12v-4.11l5.21-5.72c.555.213 1.159.33 1.79.33ZM5.525 8 3.703 6h14.599L16.48 8H5.525Z" })));
});
